import { IUserSubscribedResponse, IUserSubscribedParameters } from "@edgetier/watchtower-types";
import { axios } from "utilities/axios";

/**
 * Request user subscribed results with pagination.
 * @param url              user subscribed URL.
 * @param parameters
 * @param nextPage         Optional URL of the next page to load.
 * @returns                Promise of an array of user subscribed results.
 */
export const requestUserSubscribed = async (
    url: string,
    parameters: IUserSubscribedParameters = {},
    nextPage?: string
) => {
    // If loading the next page, the backend provides a full URL. Otherwise construct a search query.
    const request = nextPage
        ? axios.get<IUserSubscribedResponse>(nextPage)
        : axios.get<IUserSubscribedResponse>(url, { params: parameters });

    const response = await request;
    return response.data;
};
